declare function visualizarArquivoEmModal(url: string, extensao: string, resolucao?: any): void;

abstract class NotificationProvider {
    protected static toastContainer: HTMLButtonElement;

    private static MAX_TOASTS = 3;

    private static FILA: Array<Toast> = [];

    protected static STATUS_EMISSAO_RELATORIO = {
        PENDENTE: 0,
        EMITIDO: 1,
        ERRO: 2
    };

    constructor() {
    }

    static showToast(
        toastId: string,
        title: string,
        mensagem: string,
        progress: number,
        link: string,
        iconPath: string,
        tituloRelatorio?: string,
        dataHoraFim?: string,
        nomeUsuario?: string,
        extensaoArquivo?: string
    ): void {
        this.toastContainer = <HTMLButtonElement>document.getElementById('toastContainer');
        let objectToast = new Toast(toastId, title, mensagem, progress, link, iconPath, tituloRelatorio, dataHoraFim, nomeUsuario, extensaoArquivo);

        // se já existe no DOM, atualiza
        if ($(`#${toastId}`).length > 0) {
            const toast = $(`#${toastId}`).first();
            this.updateToast(toast, objectToast);
            return;
        }

        // remove entradas duplicadas na fila (mesmo toastId)
        this.FILA = this.FILA.filter(t => t.getToastId !== toastId);

        // adiciona e processa fila
        this.FILA.push(objectToast);
        this.processaFila();
    }

    static updateToast(toast: JQuery, objectToast: Toast) {
        // se o elemento foi removido ou marcado como fechado, ignora
        const el = document.getElementById(objectToast.getToastId);
        if (!el || el.getAttribute('data-closed') === '1') {
            return;
        }

        if (objectToast.getMensagem) {
            toast.find('.toast-body p').first().html(objectToast.getMensagem);
        }

        if (objectToast.getProgress != null) {
            if (toast.find('.progress').length > 0) {
                toast.find('.progress').first().css('width', `${objectToast.getProgress}%`);
                toast.find('.progress-text').first().html(`${objectToast.getProgress}%`);
            } else {
                // evita múltiplas barras (se já existe .progress-bar, remove antes)
                if (toast.find('.progress-bar').length === 0) {
                    toast.find('.toast-itens').first().after(this.criaProgressBar(objectToast));
                }
            }
            // corrige o margin (sem ;)
            toast.find('.toast-body p').first().css('margin', '0 0 5px');
        } else {
            toast.find('.progress-bar').first().remove();
            toast.find('.toast-itens p').first().css('margin', '');
        }

        if (objectToast.getLink) {
            // se já existem itens, evita duplicar
            if (toast.find('.toast-itens').length === 0 || toast.find('.toast-itens .toast-itens-buttons').length === 0) {
                let itens = document.createElement('div');
                itens.className = 'toast-itens';

                let divButtons = document.createElement('div');
                divButtons.className = 'toast-itens-buttons';
                divButtons.appendChild(this.criaBotaoVisualizar(objectToast));
                divButtons.appendChild(this.criaBotao(objectToast));

                // remove infos antigas para adicionar de novo
                toast.find('.toast-info-relatorio').closest('.toast-itens').remove();

                itens.appendChild(this.criaDivInfosRelatorio(objectToast));
                itens.appendChild(divButtons);
                toast.find('.toast-body').first().append(itens);
            } else {
                // só atualiza infos se já existem
                const divInfo = toast.find('.toast-info-relatorio').first();
                if (divInfo.length > 0) {
                    divInfo.find('p').first().text(objectToast.getTituloRelatorio || '');
                    divInfo.find('small').first().text(`${objectToast.getDataHoraFim || ''} - ${objectToast.getNomeUsuario || ''}`);
                }
            }
        }
    }

    private static criaDivInfosRelatorio(objectToast: Toast) {
        const divInfo = document.createElement('div');
        divInfo.className = 'toast-info-relatorio';

        const spanTitulo = document.createElement('p');
        spanTitulo.innerText = objectToast.getTituloRelatorio;
        spanTitulo.title = objectToast.getTituloRelatorio;

        const small = document.createElement('small');
        small.innerText = `${objectToast.getDataHoraFim} - ${objectToast.getNomeUsuario}`;
        small.title = `${objectToast.getDataHoraFim} - ${objectToast.getNomeUsuario}`;

        divInfo.appendChild(spanTitulo);
        divInfo.appendChild(small);

        return divInfo;
    }


    private static processaFila(): void {
        if (!this.toastContainer) return;

        let count = this.toastContainer.querySelectorAll('.toast.show').length;

        while (count < this.MAX_TOASTS && this.FILA.length > 0) {
            const objectToast = this.FILA.shift();
            // se já foi removido da fila por algum motivo, pula
            if (!objectToast) continue;

            const toast = document.createElement('div');
            toast.id = objectToast.getToastId;
            toast.className = 'toast show';

            toast.appendChild(this.criaHeader(objectToast));
            toast.appendChild(this.criaBody(objectToast));

            this.toastContainer.appendChild(toast);
            this.updateToast($(toast), objectToast);

            count++;
        }
    }

    protected static criaHeader(objectToast: Toast) {
        let header = document.createElement('div');
        header.className = 'toast-header';

        if (objectToast.getIconPath) {
            let i = document.createElement('i');
            i.className = objectToast.getIconPath + ' icon';
            header.appendChild(i);
        }

        let titleSpan = document.createElement('span');
        titleSpan.className = 'title';
        titleSpan.innerHTML = objectToast.getTitle;

        let close = document.createElement('div');
        close.innerHTML = '&times;'
        close.className = 'close';

        close.onclick = () => {
            const el = document.getElementById(objectToast.getToastId);

            if (el) {
                // marca como fechado
                el.setAttribute('data-closed', '1');

                // adiciona a classe que dispara a animação
                el.classList.add('closing');

                // só remove quando o efeito terminar
                el.addEventListener('transitionend', () => {
                    el.remove();

                    // remove da fila somente depois que sumiu
                    this.FILA = this.FILA.filter(t => t.getToastId !== objectToast.getToastId);
                    this.processaFila();
                }, { once: true });

                // para não remover antes da animação
                return;
            }

            this.FILA = this.FILA.filter(t => t.getToastId !== objectToast.getToastId);
            this.processaFila();
        };

        header.appendChild(titleSpan);
        header.appendChild(close);
        return header;
    }

    protected static criaBody(objectToast: Toast) {
        const body = document.createElement('div');
        body.className = 'toast-body';

        const itens = document.createElement('div');
        itens.className = 'toast-itens';

        const p = document.createElement('p');
        p.innerHTML = objectToast.getMensagem;

        itens.appendChild(p);
        body.appendChild(itens);

        if (objectToast.getProgress != null) {
            const progressBar = this.criaProgressBar(objectToast);
            body.appendChild(progressBar);
        }

        const itensInfos = document.createElement('div');
        itensInfos.className = 'toast-itens';
        itensInfos.appendChild(this.criaDivInfosRelatorio(objectToast));
        body.appendChild(itensInfos);

        return body;
    }

    private static criaProgressBar(objectToast: Toast) {
        let progressBar = document.createElement('div');
        progressBar.className = 'progress-bar';

        let progressDiv = document.createElement('div');
        progressDiv.className = 'progress';

        let progressText = document.createElement('span');
        progressText.className = 'progress-text';
        if (objectToast.getProgress > 0) {
            progressText.innerText = `${objectToast.getProgress}%`;
        }

        progressDiv.style.width = `${objectToast.getProgress}%`;
        progressDiv.appendChild(progressText);
        progressBar.appendChild(progressDiv);
        return progressBar;
    }

    private static criaBotao(objectToast: Toast, executionId?: string) {
        let iconDownload = document.createElement('i');
        iconDownload.className = 'fa-solid fa-arrow-down-to-line icon';
        iconDownload.style.marginRight = '5px';

        let link = objectToast.getLink;
        if (executionId) {
            link = `/padrao/emissaorelatorios/download?executionId=${executionId}`;
        }

        let buttonBaixar = document.createElement('button');
        buttonBaixar.className = 'toast-button';
        buttonBaixar.innerHTML = iconDownload.outerHTML + 'Baixar';
        buttonBaixar.onclick = () => {
            void fetch(link, { credentials: 'same-origin' })
                .then(async response => {
                    if (!response.ok) {
                        throw new Error(`Falha ao baixar o arquivo (${response.status})`);
                    }

                    const blob = await response.blob();
                    const objectUrl = URL.createObjectURL(blob);
                    const anchor = document.createElement('a');
                    const nomeArquivo = this.extrairNomeArquivo(response.headers.get('content-disposition'));

                    anchor.href = objectUrl;
                    anchor.download = nomeArquivo || '';
                    document.body.appendChild(anchor);
                    anchor.click();
                    anchor.remove();
                    URL.revokeObjectURL(objectUrl);

                    if (!executionId) $(`#${objectToast.getToastId}`).remove();
                })
                .catch(() => {
                    // mantém o toast se o download falhar
                });
        }

        return buttonBaixar;
    }

    private static criaBotaoVisualizar(objectToast: Toast, executionId?: string) {
        if (objectToast.getExtensaoArquivo !== 'pdf') {
            return document.createElement('span');
        }

        let iconEye = document.createElement('i');
        iconEye.className = 'fa-solid fa-eye icon';
        iconEye.style.marginRight = '5px';

        let id = objectToast.getToastId;
        if (executionId) {
            id = executionId;
        }

        let buttonVisualizar = document.createElement('button');
        buttonVisualizar.className = 'toast-button-visualizar';
        buttonVisualizar.innerHTML = iconEye.outerHTML + 'Visualizar';
        buttonVisualizar.onclick = () => {
            visualizarArquivoEmModal(`/padrao/emissaorelatorios/visualizar?executionId=${id}`, 'pdf')
        }

        return buttonVisualizar;
    }



    /** ---------------- ---------------- ----------------- */
    /** --- FUNÇÕES DA MODAL DE HISTÓRICO DE RELATÓRIOS --- */
    /** ---------------- ---------------- ----------------- */

    static showToastModalHistorico(
        toastId: string,
        title: string,
        mensagem: string
    ): void {
        this.toastContainer = <HTMLButtonElement>document.getElementById('toastContainer');
        let objectToast = new Toast(toastId, title, mensagem);

        // se já existe no DOM, ignora
        if ($(`#${toastId}`).length > 0) {
            return;
        }

        // Mostra modal
        const toastElement = this.getToastHistorico(objectToast);
        this.toastContainer.appendChild(toastElement);
    }

    static updateToastModalHistorico(
        toastId: string,
        title: string,
        mensagem: string,
    ) {
        let objectToast = new Toast(toastId, title, mensagem);
        const existing = document.body.contains(document.getElementById(toastId));

        if (existing) {
            document.getElementById(toastId).remove();
            this.toastContainer.appendChild(this.getToastHistorico(objectToast));
            return;
        }
    }

    public static getToastHistorico(objectToast: Toast): HTMLDivElement {
        const toastElement = document.createElement('div');
        toastElement.id = objectToast.getToastId;
        toastElement.className = 'toast-historico show';

        toastElement.appendChild(this.criaHeader(objectToast));
        toastElement.appendChild(this.criaBodyHistorico(objectToast));

        return toastElement;
    }

    protected static criaBodyHistorico(objectToast: Toast) {
        const lista = JSON.parse(objectToast.getMensagem);

        const body = document.createElement('div');
        body.className = 'toast-body';

        if (!Array.isArray(lista) || lista.length === 0) {
            const p = document.createElement('p');
            p.textContent = 'Nenhum relatório disponível no histórico.';
            body.appendChild(p);

            const btnHistorico = this.criaBotaoHistorico();
            body.appendChild(btnHistorico);

            return body;
        }

        lista.forEach(rel => {
            objectToast.setExtensaoArquivo = rel.extensao;
            const itens = document.createElement('div');
            itens.className = 'toast-itens';

            // Ícones
            const divIcon = document.createElement('div');
            const iconCheck = document.createElement('i');
            const iconCheckDisabled = rel.status === this.STATUS_EMISSAO_RELATORIO.EMITIDO ? '' : ' icon-check-disabled ';
            const icon = rel.status === this.STATUS_EMISSAO_RELATORIO.ERRO ? 'fa-circle-xmark icon-error-toast' : 'fa-circle-check icon-check-toast';
            iconCheck.className = `fa-solid ${icon} fa-xl ${iconCheckDisabled}`;

            this.adicionaIconNaoVisulizado(divIcon, rel.visualizado);
            divIcon.append(iconCheck);

            // Infos
            const divInfo = document.createElement('div');
            divInfo.className = 'toast-info-relatorio';

            const spanTitulo = document.createElement('p');
            spanTitulo.textContent = rel.nomeRelatorio;
            spanTitulo.title = rel.nomeRelatorio;

            const small = document.createElement('small');
            small.textContent = this.formatHoraEUsuario(rel.dataHoraFim, rel.nomeUsuario);
            small.title = `${this.formatHoraEUsuario(rel.dataHoraFim, rel.nomeUsuario)}`;

            divInfo.append(spanTitulo, small);

            const divButtons = this.criaDivButtonsHistorico(rel.status, rel.executionId, objectToast);

            itens.append(divIcon, divInfo, divButtons);
            body.appendChild(itens);

            const hr = document.createElement('hr');
            hr.className = 'toast-hr';
            body.appendChild(hr);
        });

        const btnHistorico = this.criaBotaoHistorico();
        body.appendChild(btnHistorico);

        return body;
    }

    private static adicionaIconNaoVisulizado(divIcon: HTMLDivElement, visualizado: boolean): void {
        if (!visualizado) {
            // bolinha laranja
            const spanDot = document.createElement('span');
            spanDot.style.width = '8px';
            spanDot.style.height = '8px';
            spanDot.style.backgroundColor = 'orange';
            spanDot.style.borderRadius = '50%';
            spanDot.style.border = '2px solid white';
            spanDot.style.display = 'inline-block';
            divIcon.appendChild(spanDot);
        }
    }

    private static formatHoraEUsuario(dataHoraFim: { date: string }, nomeUsuario: string): string {
        if (dataHoraFim && dataHoraFim.date) {
            const data = new Date(dataHoraFim.date.replace(' ', 'T'));

            const dia   = String(data.getDate()).padStart(2, '0');
            const mes   = String(data.getMonth() + 1).padStart(2, '0');
            const ano   = data.getFullYear();

            const hora  = String(data.getHours()).padStart(2, '0');
            const min   = String(data.getMinutes()).padStart(2, '0');

            return `${dia}/${mes}/${ano} - ${hora}:${min} - ${nomeUsuario}`;
        }

        return `${nomeUsuario}`;
    }

    private static criaDivButtonsHistorico(status: number, executionId: string, objectToast: Toast) {
        let divButtons: HTMLDivElement;

        if (status === this.STATUS_EMISSAO_RELATORIO.EMITIDO) {
            divButtons = document.createElement('div');
            divButtons.className = 'toast-itens-buttons';
            divButtons.append(
                this.criaBotaoVisualizar(objectToast, executionId),
                this.criaBotao(objectToast, executionId)
            );

            return divButtons;
        }

        if (status === this.STATUS_EMISSAO_RELATORIO.ERRO) {
             divButtons = document.createElement('div');
             divButtons.className = 'toast-itens-buttons';
             const spanError = document.createElement('span');
             spanError.textContent = 'Falha ao gerar o relatório';
             spanError.style.color = '#c33232';
             divButtons.appendChild(spanError);

             return divButtons;
        }

        divButtons = document.createElement('div');
        divButtons.style.display = 'flex';
        divButtons.style.alignItems = 'center';
        divButtons.className = '';
        divButtons.style.marginRight = '18px';

        // Ícone girando
        const iconAguarde = document.createElement('i');
        iconAguarde.className = 'fa-solid fa-rotate fa-spin';
        iconAguarde.style.marginRight = '5px';

        divButtons.appendChild(iconAguarde);

        const spanText = document.createElement('span');
        spanText.textContent = 'Aguardando processamento...';
        divButtons.appendChild(spanText);

        return divButtons;

    }

    private static criaBotaoHistorico() {
        const btnHistorico = document.createElement('button');
        btnHistorico.className = 'toast-button btn-historico';
        btnHistorico.textContent = 'Ver histórico';
        btnHistorico.onclick = () => {
            window.open('/padrao/emissaorelatorios', "_blank");
        }

        return btnHistorico;
    }

    private static extrairNomeArquivo(contentDisposition: string | null): string | undefined {
        if (!contentDisposition) {
            return undefined;
        }

        const match = contentDisposition.match(/filename\*?=(?:UTF-8''|\")?([^\";]+)/i);
        if (!match || !match[1]) {
            return undefined;
        }

        return decodeURIComponent(match[1].replace(/\"/g, '').trim());
    }
}

class Toast {
    private toastId: string;
    private mensagem: string;
    private title: string;
    private progress: number;
    private link: string;
    private iconPath: string;
    private tituloRelatorio: string;
    private dataHoraFim: string;
    private nomeUsuario: string;
    private extensaoArquivo: string;

    constructor(toastId: string, title: string, mensagem: string, progress?: number, link?: string, iconPath?: string, tituloRelatorio?: string, dataHoraFim?: string, nomeUsuario?: string, extensaoArquivo?: string) {
        this.toastId = toastId;
        this.title = title;
        this.mensagem = mensagem;
        this.progress = progress;
        this.link = link;
        this.iconPath = iconPath;
        this.tituloRelatorio = tituloRelatorio;
        this.dataHoraFim = dataHoraFim;
        this.nomeUsuario = nomeUsuario;
        this.extensaoArquivo = extensaoArquivo;
    }

    public get getMensagem(): string {
        return this.mensagem;
    }

    public get getToastId(): string {
        return this.toastId;
    }

    public get getProgress(): number {
        return this.progress;
    }

    public get getLink(): string {
        return this.link;
    }


    public get getTitle(): string {
        return this.title;
    }

    public get getIconPath(): string {
        return this.iconPath;
    }

    public get getTituloRelatorio(): string {
        return this.tituloRelatorio;
    }

    public get getDataHoraFim(): string {
        return this.dataHoraFim;
    }

    public get getNomeUsuario(): string {
        return this.nomeUsuario;
    }

    public get getExtensaoArquivo(): string {
        return this.extensaoArquivo;
    }

    public set setExtensaoArquivo(extensaoArquivo: string) {
        this.extensaoArquivo = extensaoArquivo;
    }
}
